// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 185 ? "babelTransform" : chunkId) + "-chunk-" + {"114":"b49e44ddaa980ae89be5","185":"3c4c72a36c0a477280b5"}[chunkId] + ".js";
};